import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
// eslint-disable-next-line no-restricted-imports
import { ArrowRightSvg } from "../icons/arrow-right";

export const IconArrowRight = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <ArrowRightSvg />
    </SvgIcon>
);
